module.exports = __webpack_public_path__ + "static/media/over3.f9ddfe0b.png";